var _circle, _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCheckUpStopped(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.99957,
    cy: 6.99957,
    r: 6.22222,
    fill: "var(--yellow-6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36882 3.11133H7.75733L7.66337 8.52967H6.46278L6.36882 3.11133ZM6.22266 10.0435C6.22266 9.80683 6.3027 9.60847 6.46278 9.44839C6.62286 9.28831 6.82121 9.20827 7.05785 9.20827C7.30145 9.20827 7.50329 9.28831 7.66337 9.44839C7.82345 9.60847 7.90349 9.80683 7.90349 10.0435C7.90349 10.2871 7.82345 10.4889 7.66337 10.649C7.50329 10.8091 7.30145 10.8891 7.05785 10.8891C6.82121 10.8891 6.62286 10.8091 6.46278 10.649C6.3027 10.4819 6.22266 10.2801 6.22266 10.0435Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckUpStopped);
export default __webpack_public_path__ + "static/media/checkUpStopped.3e38402eb04247a435486be11a609f07.svg";
export { ForwardRef as ReactComponent };